import { Result } from 'domain/types';
import ReadFeaturesClient from 'use-case/features/read/readFeaturesClient';
import Feature from 'domain/entity/feature';

export type ReadFeaturesResult = Result<Feature[]>;
export type ReadFeatures = () => Promise<ReadFeaturesResult>;

export default (readFeaturesClient: ReadFeaturesClient): ReadFeatures => (): Promise<ReadFeaturesResult> => readFeaturesClient();
